import React from 'react'

import theme from '../theme/news12'

const Spinner = () => (
  <div className='container-loader'>
    <div className='loader' />
    <style jsx>
      {`
      .container-loader {
        margin: 30px 0;
        display: flex;
        justify-content: center;
      }
    
      .loader {
        border: 6px solid ${theme.colors.veryLightGray}; 
        border-top: 6px solid ${theme.colors.lightBlue};
        border-radius: 50%;
        width: 32px;
        height: 32px;
        animation: spin 2s linear infinite;
      }

      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}
    </style>
  </div>
)

export { Spinner }
